/**
 * Imported only once by our main.ts entry point.
 * It requires every JS file under apps/b2b-ui/ and filters out spec files so that we don't have to do it manually.
 */
// eslint-disable-next-line no-undef
const requireFiles = require.context('../../apps/b2b-ui', true, /^\.\/(?!node_modules\/)(?:(?!\.spec\.js$).)*\.js$/);
export default requireFiles.keys().map((key) => requireFiles(key));
